import {
  SwapHoriz as CarsInNegotiationIcon,
  FlashOn as LiveActionIcon,
  Garage as MyGarageIcon,
  DirectionsCar as SellMyCarIcon,
  Update as UpcomingCarsIcon,
  WatchLater as WatchListIcon,
} from "@mui/icons-material";
import { routes } from "./routes";

//TODO: Convert this to object in key value
// NOTE: Keep these values in sync with redirection to dashboard files
// CarEstimateAndAuctionForm.jsx, sigin.jsx redirection redirection
export const SellerSidebarOptions = [
  {
    label: "My Garage",
    value: "myGarage",
    navigationRoute: routes.myGarage
    // icon: <MyGarageIcon />,
  },
  // {
  //   label: "Sell My Car",
  //   value: "sellMyCar",
  //   navigationRoute: routes.sellMyCar
  //   // icon: <SellMyCarIcon />,
  // },
  {
    label: "Upcoming Cars",
    value: "upcomingCars",
    navigationRoute: routes.upcomingCars
    // icon: <UpcomingCarsIcon />,
  },
  {
    label: "Buy Now",
    value: "buyNow",
    icon: <LiveActionIcon />,
    navigationRoute: routes.buyNow
  },
  {
    label: "Live Auction",
    value: "liveAuction",
    navigationRoute: routes.liveAuction
    // icon: <LiveActionIcon />,
  },
  {
    label: "Negotiation Live Auction",
    value: "carsInNegotiation",
    navigationRoute: routes.carsInNegotiation,
    group: "negotiation",
    groupLabel: "Negotiation"
    // icon: <CarsInNegotiationIcon />,
  },
  {
    label: "Negotiation Buy Now",
    value: "carsInNegotiationBuyNow",
    navigationRoute: routes.carsInNegotiationBuyNow,
    group: "negotiation",
    groupLabel: "Negotiation"
    // icon: <CarsInNegotiationIcon />,
  },
  // {
  //   label: "UnSold Cars",
  //   value: "unsoldCars",
  //   navigationRoute: ``
  //   // icon: <CarsInNegotiationIcon />,
  // },
  // {
  //   label: "Watch list",
  //   value: "watchList",
  //   navigationRoute: routes.watchList
  //   // icon: <WatchListIcon />,
  // },
  {
    label: "Car Estimate",
    value: "carEstimate",
    navigationRoute: routes.carEstimate,
    dontShow: true,
    // icon: <CarsInNegotiationIcon />,
  },
  {
    label: "Rejected Cars",
    value: "rejectedCars",
    icon: <UpcomingCarsIcon />,
    navigationRoute: routes.rejectedCars,
  },
  {
    label: "My Orders",
    value: "myOrders",
    icon: <UpcomingCarsIcon />,
    navigationRoute: routes.myOrders,
  },
  {
    label: "Profile",
    value: "profile",
    icon: <UpcomingCarsIcon />,
    navigationRoute: routes.profile,
  },
];
